export const environment = {
  envName: 'client-staging',
  production: false,
  showPilotDisclaimer: true,
  apiV1: "/api/v1",
  apiUrl: "https://bb-api.orthoplex.ca/"
};
